const baseConfig = { maxWidth: 900, minWidth: 570, mountOffset: 0 };

export default function (item) {
  switch (item.filter.color) {
    case 'white':
      return {
        ...baseConfig,
        innerId: 'clothes_rail_88_36_3_white_in',
        outerId: 'clothes_rail_88_36_3_white_out',
        fullId: '30460934',
      };
    case 'dark_grey':
      return {
        ...baseConfig,
        innerId: 'clothes_rail_88_36_3_dark_grey_in',
        outerId: 'clothes_rail_88_36_3_dark_grey_out',
        fullId: '10460949',
      };
    default:
      break;
  }
}
